import React from 'react';
import { useBrand } from '../brand/BrandProvider';
import { resolveAbsoluteApiPath } from '../utils/apiOrigin';

interface BrandLogoProps {
  markClassName?: string;
  markImageClassName?: string;
  wordmarkClassName?: string;
  showWordmark?: boolean;
}

const DEFAULT_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/logo-default.png`;

const BrandLogo: React.FC<BrandLogoProps> = ({
  markClassName = 'app-layout__logo-mark',
  markImageClassName = 'app-layout__logo-mark-image',
  wordmarkClassName = 'app-layout__logo-text',
  showWordmark = true,
}) => {
  const { brand } = useBrand();
  const companyLogoSrc = brand.logoUrl ? resolveAbsoluteApiPath(brand.logoUrl) : null;

  return (
    <>
      <div className={markClassName}>
        <img
          src={companyLogoSrc || DEFAULT_LOGO_SRC}
          alt=""
          className={markImageClassName}
          onError={(event) => {
            const target = event.target as HTMLImageElement;
            if (companyLogoSrc && target.src !== DEFAULT_LOGO_SRC) {
              target.src = DEFAULT_LOGO_SRC;
              return;
            }
            target.style.display = 'none';
          }}
        />
      </div>
      {showWordmark && (
        <span className={wordmarkClassName}>Fasterclass</span>
      )}
    </>
  );
};

export default BrandLogo;
